import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IThongTinDiaPhuong } from 'app/shared/model/thong-tin-dia-phuong.model';
import { getEntities as getThongTinDiaPhuongs } from 'app/entities/thong-tin-dia-phuong/thong-tin-dia-phuong.reducer';
import { getEntities as getDonViHanhChinhs } from 'app/entities/don-vi-hanh-chinh/don-vi-hanh-chinh.reducer';
import { IDonViHanhChinh } from 'app/shared/model/don-vi-hanh-chinh.model';
import { getEntity, updateEntity, createEntity, reset } from './don-vi-hanh-chinh.reducer';

export const DonViHanhChinhUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const thongTinDiaPhuongs = useAppSelector(state => state.thongTinDiaPhuong.entities);
  const donViHanhChinhs = useAppSelector(state => state.donViHanhChinh.entities);
  const donViHanhChinhEntity = useAppSelector(state => state.donViHanhChinh.entity);
  const loading = useAppSelector(state => state.donViHanhChinh.loading);
  const updating = useAppSelector(state => state.donViHanhChinh.updating);
  const updateSuccess = useAppSelector(state => state.donViHanhChinh.updateSuccess);
  const handleClose = () => {
    props.history.push('/don-vi-hanh-chinh');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getThongTinDiaPhuongs({}));
    dispatch(getDonViHanhChinhs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...donViHanhChinhEntity,
      ...values,
      thongTinChung: thongTinDiaPhuongs.find(it => it.id.toString() === values.thongTinChung.toString()),
      cha: donViHanhChinhs.find(it => it.id.toString() === values.cha.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...donViHanhChinhEntity,
          thongTinChung: donViHanhChinhEntity?.thongTinChung?.id,
          cha: donViHanhChinhEntity?.cha?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="xtdtApp.donViHanhChinh.home.createOrEditLabel" data-cy="DonViHanhChinhCreateUpdateHeading">
            <Translate contentKey="xtdtApp.donViHanhChinh.home.createOrEditLabel">Create or edit a DonViHanhChinh</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="don-vi-hanh-chinh-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('xtdtApp.donViHanhChinh.ten')}
                id="don-vi-hanh-chinh-ten"
                name="ten"
                data-cy="ten"
                type="text"
              />
              <ValidatedField label={translate('xtdtApp.donViHanhChinh.ma')} id="don-vi-hanh-chinh-ma" name="ma" data-cy="ma" type="text" />
              <ValidatedField
                label={translate('xtdtApp.donViHanhChinh.cap')}
                id="don-vi-hanh-chinh-cap"
                name="cap"
                data-cy="cap"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.donViHanhChinh.geometry')}
                id="don-vi-hanh-chinh-geometry"
                name="geometry"
                data-cy="geometry"
                type="text"
              />
              <ValidatedField
                id="don-vi-hanh-chinh-thongTinChung"
                name="thongTinChung"
                data-cy="thongTinChung"
                label={translate('xtdtApp.donViHanhChinh.thongTinChung')}
                type="select"
              >
                <option value="" key="0" />
                {thongTinDiaPhuongs
                  ? thongTinDiaPhuongs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="don-vi-hanh-chinh-cha"
                name="cha"
                data-cy="cha"
                label={translate('xtdtApp.donViHanhChinh.cha')}
                type="select"
              >
                <option value="" key="0" />
                {donViHanhChinhs
                  ? donViHanhChinhs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/don-vi-hanh-chinh" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DonViHanhChinhUpdate;
